import {FilterArgs, PaginationArgs, ThirdPartyId} from "platformed-client/types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";

export const thirdParty = typedQuery(
  ["tprm", "thirdParty", param<ThirdPartyId>("thirdPartyId")],
  async thirdPartyId => {
    return await api.tprm.thirdParties.get(thirdPartyId);
  },
);

export const thirdParties = typedQuery(
  ["tprm", "thirdParties", param<PaginationArgs>("paginationArgs"), param<FilterArgs>("filterArgs")],
  async (paginationArgs, filterArgs) => {
    return await api.tprm.thirdParties.list(paginationArgs, filterArgs);
  },
);

export const thirdPartyEngagements = typedQuery(
  ["tprm", "thirdPartyEngagements", param<ThirdPartyId>("thirdPartyId")],
  async thirdPartyId => {
    return (
      await api.tprm.engagements.search(
        {limit: 1000},
        {
          order: [],
          filter: {
            kind: "Expression",
            field: "thirdParty",
            condition: "Equals",
            value: {kind: "Uuid", value: thirdPartyId},
            negated: false,
          },
        },
      )
    ).items;
  },
);

export const thirdPartyOperationalContexts = typedQuery(
  ["tprm", "thirdPartyOperationalContexts", param<ThirdPartyId>("thirdPartyId")],
  async thirdPartyId => {
    return await api.tprm.thirdParties.listOperationalContexts(thirdPartyId);
  },
);

export const thirdPartyPortalUsers = typedQuery(
  ["tprm", "thirdPartyPortalUsers", param<ThirdPartyId>("thirdPartyId")],
  async thirdPartyId => {
    return await api.tprm.thirdParties.listPortalUsers(thirdPartyId);
  },
);
